import React from "react";
import {Nullable} from "@data-force/app";
import {Redirect, Route, Switch} from "react-router";
import {connect} from "react-redux";
import {getActiveLanguage, Language} from "react-localize-redux";
import dayjs from "dayjs";
import NavigationBar from "../../components/NavigationBar/NavigationBar";
import HeaderBar from "../../components/HeaderBar/HeaderBar";
import HomeView from "../HomeView/HomeView";
import JobsView from "../JobsView/JobsView";
import FaqView from "../FaqView/FaqView";
import {getHistoryParams} from "../../utils/common";
import HistoryParams from "../../interfaces/historyParams";
import "./MainView.scss";
import JobClaimDialog from "../../components/JobClaimDialog/JobClaimDialog";
import {setIsMobile} from "../../store/actions/mobile";
import {SetIsMobileAction} from "../../interfaces/store/actions/mobile";
import NoMatchView from "../NoMatchView/NoMatchView";
import StoreState from "../../interfaces/store/storeState";
import SupportView from "../SupportView/SupportView";
import {RoutesMap} from "../../interfaces/common";
import {Routes} from "../../utils/constants";
import UnauthorizedView from "../UnauthorizedView/UnauthorizedView";

interface DispatchProps {
    setIsMobile(): SetIsMobileAction
}

interface StateProps {
    activeLanguage: Language
    pmUser: boolean
}

type Props = StateProps & DispatchProps;

class MainView extends React.Component<Props> {
    componentDidMount(): void {
        window.addEventListener("resize", this.props.setIsMobile);
        dayjs.locale(this.props.activeLanguage.code);
    }

    render() {
        const historyParams: Nullable<HistoryParams> = getHistoryParams();
        const {pmUser}: Props = this.props;
        const {
            JOBS, FAQ, SUPPORT, UNAUTHORIZED,
        }: RoutesMap = Routes;

        return (
            <div className="df-cmp">
                <NavigationBar/>
                <div className="df-container">
                    <HeaderBar/>
                    <main className="df-content">
                        <Switch>
                            <Route exact path={`/${historyParams?.idpId}/`}>
                                {pmUser ? <Redirect to={`/${historyParams?.idpId}/${JOBS}`}/> : <HomeView/>}
                            </Route>
                            <Route exact path={`/${historyParams?.idpId}/${JOBS}`}>
                                <JobsView/>
                            </Route>
                            <Route exact path={`/${historyParams?.idpId}/${FAQ}`}>
                                <FaqView/>
                            </Route>
                            <Route exact path={`/${historyParams?.idpId}/${SUPPORT}`}>
                                <SupportView/>
                            </Route>
                            <Route exact path={`/${historyParams?.idpId}/${UNAUTHORIZED}`}>
                                <UnauthorizedView/>
                            </Route>
                            <Route path="*">
                                <NoMatchView/>
                            </Route>
                        </Switch>
                    </main>
                </div>
                <JobClaimDialog/>
            </div>
        );
    }
}

function mapStateToProps(state: StoreState): StateProps {
    return {
        activeLanguage: getActiveLanguage(state.localize),
        pmUser: state.user.pmUser,
    };
}

const mapDispatchToProps: DispatchProps = {
    setIsMobile,
};

export default connect(mapStateToProps, mapDispatchToProps)(MainView);
